/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { isNonEmptyArray } from '@apollo/client/utilities';
import { type LoaderFunctionArgs } from 'react-router-dom';

export const pipeLoaders =
  ({
    sequence,
    concurrent,
  }: {
    sequence?: Array<(args: LoaderFunctionArgs) => Promise<Response | null>>;
    concurrent?: Array<(args: LoaderFunctionArgs) => Promise<null>>;
  }) =>
  async (args: LoaderFunctionArgs) => {
    if (isNonEmptyArray(sequence)) {
      for (const promiseFn of sequence) {
        const result = await promiseFn(args);

        if (result instanceof Response) return result;
      }
    }

    if (isNonEmptyArray(concurrent)) {
      await Promise.all(concurrent.map((c) => c(args)));
    }

    return null;
  };
